import { useContext, useEffect } from "react";

import { getAnalytics } from "@tm/insurance/analytics";
import { FormattedText, H5Tag, OrderListingComp } from "@tm/static";
import { ExperimentTrackingString, useBreakpointV2 } from "@tm/ui-widgets";

import { initializePageTracking } from "@tm/insurance/analytics/xdm";
import { pageStack, PAGE_NAME_CONSTANTS } from "@tm/insurance/navigation";
import { PageContainer, PageGreyWrap } from "./OrderListingPage.style";
import { OrderListingPageProps } from "./types";

const analytics = getAnalytics();

const OrderListingPage = ({ orderListingData }: OrderListingPageProps) => {
  const device = useBreakpointV2();
  const experiment = useContext(ExperimentTrackingString) || "";

  useEffect(() => {
    pageStack.push(PAGE_NAME_CONSTANTS.ORDER_LISTING);
    analytics?.trackPageLoadEvent({ pageName: "ORDER_SUMMARY", experiment });
    initializePageTracking({
      page_context: {
        page_name: "thankyou",
        funnel_step: "thankyou",
        page_type: "funnel",
        subpage_name: "order_listing",
      },
    });
  }, []);

  return (
    <PageContainer id={"pageId"}>
      <PageGreyWrap>
        {device == "lg" && (
          <H5Tag>
            <FormattedText value={`My Orders (${orderListingData?.length})`} />
          </H5Tag>
        )}
        <OrderListingComp data={orderListingData} />
      </PageGreyWrap>
    </PageContainer>
  );
};

export default OrderListingPage;
